// extracted by mini-css-extract-plugin
export var content = "content__Yc8N";
export var fakeButtons1 = "fake-buttons1__Y3QS";
export var fakeButtons2 = "fake-buttons2__kE0D";
export var fakeButtons3 = "fake-buttons3__lCT6";
export var fakeFilter = "fake-filter__U1_d";
export var layout = "layout__gyoX";
export var rating = "rating__ap0j";